import React, { useState } from "react";

import Styles from "./SelectInputOptions.styles";
import { SelectInputOptionsProps as Props } from "./SelectInputOptions.types";
import Button from "../Button/Button";
import SelectInputOption from "../SelectInputOption/SelectInputOption";
import useI18n from "hooks/useI18n";

const SelectInputOptions: React.FC<Props> = props => {
  const { setShowModal, itemSelected, onSelectedOption } = props;
  const { value, defaultValue, options } = itemSelected;
  const t = useI18n();
  const [selectedOption, setSelectedOption] = useState<string | undefined>(
    value
  );

  const confirmHandler = () => {
    onSelectedOption?.(selectedOption);
    setShowModal(false);
  };

  const renderItem = (listItem: string, index: number) => {
    const option = listItem;
    const isActive = selectedOption === option;
    const optionStyle =
      index === 0
        ? "SelectInputOptions__firstOption"
        : "SelectInputOptions__option";

    return (
      <SelectInputOption
        key={index}
        className={optionStyle}
        option={option}
        onClick={setSelectedOption}
        isActive={isActive}
      />
    );
  };

  return (
    <Styles className="SelectInputOptions">
      <p className="SelectInputOptions__text SelectInputOptions__title">
        {defaultValue}
      </p>
      <div className="SelectInputOptions__options">
        {options.map((item: string, index: number) => {
          return renderItem(item, index);
        })}
      </div>
      <Button
        mode="PRIMARY"
        className="SelectInputOptions__button"
        onClick={confirmHandler}
        disabled={typeof selectedOption === "undefined"}
      >
        {t.common.confirm}
      </Button>
    </Styles>
  );
};

export default SelectInputOptions;
